import { render } from "./EditorApresentacaoGestao.vue?vue&type=template&id=4c386199&scoped=true"
import script from "./EditorApresentacaoGestao.vue?vue&type=script&lang=js"
export * from "./EditorApresentacaoGestao.vue?vue&type=script&lang=js"

import "./EditorApresentacaoGestao.vue?vue&type=style&index=0&id=4c386199&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c386199"]])

export default __exports__